import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const [label, setLabel] = useState("");
  const [hover, setHover] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    const pos = { x: 0, y: 0 };
    const ringPos = { x: 0, y: 0 };

    const move = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      if (dot.current) {
        dot.current.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
      }
    };

    let rafId;
    const loop = () => {
      ringPos.x += (pos.x - ringPos.x) * 0.18;
      ringPos.y += (pos.y - ringPos.y) * 0.18;
      if (ring.current) {
        ring.current.style.transform = `translate3d(${ringPos.x}px, ${ringPos.y}px, 0)`;
      }
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);

    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      if (t) {
        setHover(true);
        setLabel(t.getAttribute("data-cursor") || "");
      } else if (e.target.closest("a, button, [role=button]")) {
        setHover(true);
        setLabel("");
      } else {
        setHover(false);
        setLabel("");
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div
        ref={dot}
        className="pointer-events-none fixed left-0 top-0 z-[100] -translate-x-1/2 -translate-y-1/2"
        style={{ willChange: "transform" }}
      >
        <div className="w-1 h-1 rounded-full bg-white" />
      </div>
      <div
        ref={ring}
        className="pointer-events-none fixed left-0 top-0 z-[99]"
        style={{ willChange: "transform" }}
      >
        <div
          className={`-translate-x-1/2 -translate-y-1/2 rounded-full border flex items-center justify-center transition-all duration-300 ${
            hover
              ? "w-16 h-16 border-[#C9A050] bg-[#C9A050]/5 backdrop-blur"
              : "w-8 h-8 border-white/30"
          }`}
        >
          {label && hover && (
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#C9A050]">
              {label}
            </span>
          )}
        </div>
      </div>
    </>
  );
}
